var Column = require('../columns/column')

module.exports = Em.View.extend({
    templateName: 'ui/list/table/total',

    classNames: ['table-item table-total'],

    classNameBindings: ['content.itemClass'],

    labelViewClass: null,

    valueNames: function() {
        return _.keys(this.get('content.values'))
    }.property('content'),

    // Spans the columns before the first value column
    label: function() {
        var columns = this.get('controller.visibleColumns')
        var firstValueColumn = this._findValueColumn(_.first(this.get('valueNames')))
        return this._getSpanCell(firstValueColumn ? columns.slice(0, columns.indexOf(firstValueColumn)) : columns)
    }.property('valueNames', 'controller.visibleColumns.@each.{width,flex}'),

    cells: function() {
        var self = this
        return _.map(this.get('content.values'), function(value, name) {
            var column = self.get('controller').findColumn(name)
            var cell = self._getSpanCell([column])
            cell.style += 'text-align:' + column.get('align') + ';'
            cell.value = value
            return cell
        })
    }.property('content', 'controller.visibleColumns.@each.{width,flex}'),

    _findValueColumn: function(name) {
        return name ? this.get('controller').findColumn(name) : null
    },

    // Empty cell after the last value cell, standing in for e.g. the actions column so the values stay aligned
    trailing: function() {
        var columns = this.get('controller.visibleColumns')
        var lastValueColumn = this._findValueColumn(_.last(this.get('valueNames')))
        var trailingColumns = lastValueColumn ? columns.slice(columns.indexOf(lastValueColumn) + 1) : []
        return trailingColumns.length ? this._getSpanCell(trailingColumns) : null
    }.property('valueNames', 'controller.visibleColumns.@each.{width,flex}'),

    _getSpanCell: function(columns) {
        var props = {
            flex: 0,
            width: 0
        }
        columns.forEach(function(column) {
            props.flex += column.get('flex') || 0
            props.width += column.get('width') || 0
        })
        return Column.getLayout(props)
    }
})
